import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import classnames from 'classnames';
import createRef from '@roo/create-react-ref/createRef';
import TabBar from './TabBar';
var arrowWidth = 24; // 箭头宽度

var arrowHeight = 24; // 箭头高度

var verticalPoint = 15; // 垂直指示器高度

var horizontalPoint = 20; // 水平指示器宽度

var ScrollTableBar = /*#__PURE__*/function (_React$Component) {
  _inherits(ScrollTableBar, _React$Component);

  var _super = _createSuper(ScrollTableBar);

  function ScrollTableBar() {
    var _this;

    _classCallCheck(this, ScrollTableBar);

    _this = _super.apply(this, arguments);
    _this.tabBar = createRef();
    _this.scrollTableBar = createRef();
    _this.scrollTableBarSize = 0;
    _this.tabBarAllSize = 0;
    _this.tabListSize = [];
    _this.isShowArrow = false;
    _this.state = {
      arrow: false,
      // translateX: 0,
      translate: 0,
      maxTranslate: 0,
      tabBarAllSize: 0
    };

    _this.getTranslate = function (x, max) {
      return -Math.min(Math.max(x - _this.scrollTableBarSize, 0), max);
    };

    _this.updateTranslate = function (parm) {
      _this.setState(parm);
    };
    /**
     * 获取激活项在滚动条中的偏移距离
     * position 为与 tabIndex 的位置差
     */


    _this.getActiveItemPosition = function () {
      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      // maxTranslate 是 0 的话，就不用计算了
      var tabIndex = _this.props.tabIndex;
      var curWith = _this.tabListSize[0];

      var X = _this.tabListSize.reduce(function (all, cur, index) {
        if (index < tabIndex + position) {
          curWith = cur;
          return all + cur;
        }

        return all;
      }, 0);

      return [X, curWith];
    }; // 获取可视区域大小


    _this.getRectSize = function (ele) {
      var rect = ele.getBoundingClientRect();

      if (_this.isVertical) {
        return rect.height;
      } else {
        return rect.width;
      }
    }; // 计算最大滚动值


    _this.computeDistance = function () {
      var _this$getSize = _this.getSize,
          tabListSize = _this$getSize.tabListSize,
          tabBarAllSize = _this$getSize.tabBarAllSize,
          scrollTableBarSizeOrigin = _this$getSize.scrollTableBarSize;
      var type = _this.props.type; // 垂直时需要减去箭头的宽高 24 && 当行向为card类型时，需要减去箭头的宽度 24

      var arrowSize = 0;

      if (_this.isVertical) {
        arrowSize = arrowHeight;
      } else if (type === 'card') {
        arrowSize = arrowWidth;
      }

      var scrollTableBarSize = scrollTableBarSizeOrigin - arrowSize * 2;
      _this.tabListSize = tabListSize;
      _this.tabBarAllSize = tabBarAllSize;
      _this.scrollTableBarSize = scrollTableBarSize;
      return tabBarAllSize - scrollTableBarSize;
    };

    _this.handlePreMove = function () {
      var translate = _this.state.translate;

      if (translate !== 0) {
        var offset = _this.isVertical ? _this.scrollTableBar.current.offsetHeight : _this.scrollTableBar.current.offsetWidth;

        if (translate + offset < 0) {
          translate += offset;
        } else {
          translate = 0;
        }
      }

      _this.setState({
        translate: translate
      });
    };

    _this.handleNextMove = function () {
      var offset = _this.isVertical ? _this.scrollTableBar.current.offsetHeight - arrowHeight * 2 : _this.scrollTableBar.current.offsetWidth;
      var maxTranslate = _this.state.maxTranslate;
      var translate = _this.state.translate;

      if (translate - offset < -maxTranslate) {
        translate = -maxTranslate;
      } else {
        translate -= offset;
      }

      _this.setState({
        translate: translate
      });
    };

    _this.getTransformStyle = function () {
      if (!_this.isShowArrow) {
        return {};
      }

      var translate = _this.state.translate;
      var transform = _this.isVertical ? "translateY(".concat(translate, "px)") : "translateX(".concat(translate, "px)");
      return {
        WebkitTransform: transform,
        transform: transform,
        transition: '-webkit-transform 0.3s ease 0s'
      };
    };
    /**
     * 底部指示器位置
     */


    _this.getLineStyle = function () {
      var _this$getActiveItemPo = _this.getActiveItemPosition(0),
          _this$getActiveItemPo2 = _slicedToArray(_this$getActiveItemPo, 1),
          position = _this$getActiveItemPo2[0]; // eslint-disable-next-line


      var _this$getActiveItemPo3 = _this.getActiveItemPosition(1),
          _this$getActiveItemPo4 = _slicedToArray(_this$getActiveItemPo3, 2),
          curPosition = _this$getActiveItemPo4[0],
          cur = _this$getActiveItemPo4[1]; // 偏移值为当前元素的位置减去其高度的一半，再加上 pointer 指示器的一半高/宽度


      var translate = _this.isVertical ? position + cur / 2 - verticalPoint : position + cur / 2 - horizontalPoint;
      var transform = _this.isVertical ? "translateY(".concat(translate, "px)") : "translateX(".concat(translate, "px)");
      return {
        WebkitTransform: transform,
        transform: transform,
        transition: '-webkit-transform 0.3s ease 0s'
      };
    };

    _this.renderArrow = function () {
      var _this$state = _this.state,
          translate = _this$state.translate,
          maxTranslate = _this$state.maxTranslate,
          arrow = _this$state.arrow;
      var isNextDisabled = Math.abs(translate) === maxTranslate;
      var isPreDisabled = !translate;
      var iconPreClx = _this.isVertical ? 'roo-icon roo-icon-chevron-up' : 'roo-icon roo-icon-chevron-left';
      var iconNextClx = _this.isVertical ? 'roo-icon roo-icon-chevron-down' : 'roo-icon roo-icon-chevron-right';
      return arrow ? [/*#__PURE__*/React.createElement("a", {
        className: classnames('roo-tabs-pre', {
          disabled: isPreDisabled
        }),
        onClick: _this.handlePreMove,
        key: "roo-tabs-pre"
      }, /*#__PURE__*/React.createElement("i", {
        className: iconPreClx
      })), /*#__PURE__*/React.createElement("a", {
        className: classnames('roo-tabs-next', {
          disabled: isNextDisabled
        }),
        onClick: _this.handleNextMove,
        key: "roo-tabs-next"
      }, /*#__PURE__*/React.createElement("i", {
        className: iconNextClx
      }))] : null;
    };

    return _this;
  }

  _createClass(ScrollTableBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var autoResize = this.props.autoResize;

      if (autoResize) {
        return;
      }

      var maxTranslate = this.computeDistance();
      var translate = 0;

      if (this.isVertical) {
        translate = -Math.min(this.getActiveItemPosition(0)[0], maxTranslate);
      } else {
        translate = this.getTranslate(this.getActiveItemPosition()[0], maxTranslate);
      }

      this.setState({
        maxTranslate: maxTranslate,
        arrow: this.isShowArrow,
        translate: translate,
        tabBarAllSize: this.tabBarAllSize
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(preProps) {
      var autoResize = this.props.autoResize;

      if (autoResize) {
        return;
      }

      var maxTranslate = this.computeDistance(); // 动态项变化宽高时，设置一个 5 的阈值，防止重复更新

      if (maxTranslate > 0 && Math.abs(maxTranslate - this.state.maxTranslate) > 5) {
        this.updateTranslate({
          maxTranslate: maxTranslate,
          arrow: this.isShowArrow
        });
      } else if (maxTranslate < 0 && this.state.arrow) {
        this.updateTranslate({
          arrow: false,
          maxTranslate: 0,
          translate: 0
        });
      } // tab label 宽度改变后也需要触发更新


      if (this.tabBarAllSize !== this.state.tabBarAllSize) {
        // eslint-disable-next-line
        this.setState({
          tabBarAllSize: this.tabBarAllSize
        });
      }

      var _this$getActiveItemPo5 = this.getActiveItemPosition(),
          _this$getActiveItemPo6 = _slicedToArray(_this$getActiveItemPo5, 2),
          curItemX = _this$getActiveItemPo6[0],
          curWidth = _this$getActiveItemPo6[1];

      var _this$getActiveItemPo7 = this.getActiveItemPosition(0),
          _this$getActiveItemPo8 = _slicedToArray(_this$getActiveItemPo7, 2),
          curItemPreX = _this$getActiveItemPo8[0],
          preWidth = _this$getActiveItemPo8[1]; // @ts-ignore


      var _this$getActiveItemPo9 = this.getActiveItemPosition(2),
          _this$getActiveItemPo10 = _slicedToArray(_this$getActiveItemPo9, 2),
          curItemNextX = _this$getActiveItemPo10[0],
          nextWidth = _this$getActiveItemPo10[1];

      var translate = this.state.translate;
      var tabIndex = this.props.tabIndex; // tabsIndex 变化时，当前项的位置不可见，则主动让其可见。 20 为 tab 的 padding 值。
      // 20 是为了保证 UI 可见性

      if (preProps.tabIndex !== tabIndex) {
        if (curItemX + 20 >= this.scrollTableBarSize - translate) {
          // eslint-disable-next-line
          this.setState({
            translate: this.getTranslate(curItemX + nextWidth, maxTranslate)
          });
        } else if (curItemPreX - 20 <= -translate) {
          // eslint-disable-next-line
          this.setState({
            translate: tabIndex === 0 ? 0 : -Math.min(Math.max(curItemX - curWidth - preWidth, 0), maxTranslate)
          });
        }
      }
    }
  }, {
    key: "isArrow",
    value: function isArrow() {
      var _this$getSize2 = this.getSize,
          tabBarAllSize = _this$getSize2.tabBarAllSize,
          scrollTableBarSize = _this$getSize2.scrollTableBarSize;
      return tabBarAllSize > scrollTableBarSize;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          children = _this$props.children,
          onTabClick = _this$props.onTabClick,
          type = _this$props.type;
      var tabItems = React.Children.map(children, function (child) {
        return _Object$assign({}, child.props);
      });
      var style = this.getTransformStyle();
      return /*#__PURE__*/React.createElement("div", {
        className: "roo-tabs-container",
        ref: this.scrollTableBar
      }, this.renderArrow(), /*#__PURE__*/React.createElement(TabBar, {
        type: type,
        style: style,
        ref: this.tabBar,
        tabList: tabItems,
        value: value,
        onTabClick: onTabClick,
        pointerStyle: this.getLineStyle()
      }));
    }
  }, {
    key: "isVertical",
    get: function get() {
      var placement = this.props.placement;
      return placement === 'left' || placement === 'right';
    }
  }, {
    key: "getSize",
    get: function get() {
      var _this2 = this;

      var type = this.props.type;
      var scrollTableBarSize = this.getRectSize(this.scrollTableBar.current);
      var tabListSize = [];

      var tabBarLists = _toConsumableArray(this.tabBar.current.children); // 实际 DOM 中存在指示器需要排除


      var t = type === 'line' ? 2 : 1;
      var calDom = tabBarLists.slice(0, tabBarLists.length - t);
      var tabBarAllSize = calDom.reduce(function (pre, cur) {
        tabListSize.push(_this2.getRectSize(cur));
        return _this2.getRectSize(cur) + pre;
      }, 0);
      this.isShowArrow = tabBarAllSize > scrollTableBarSize;
      return {
        tabListSize: tabListSize,
        tabBarAllSize: tabBarAllSize,
        scrollTableBarSize: scrollTableBarSize
      };
    }
  }]);

  return ScrollTableBar;
}(React.Component);

ScrollTableBar.propTypes = {
  value: PropTypes.string,
  children: PropTypes.node,
  onTabClick: PropTypes.func,
  placement: PropTypes.string
};
ScrollTableBar.defaultProps = {
  value: '',
  children: [],
  onTabClick: function onTabClick() {},
  placement: 'top'
};
export default ScrollTableBar;